import dayjs from 'dayjs'
import { ResidentMedication } from '../types'

export const getShowAlert = (medication: ResidentMedication): boolean => {
  const { stockAlertLevel, currentStockLevel, isBelowThreshold } = medication

  if (isBelowThreshold !== undefined) {
    return isBelowThreshold
  }

  if (currentStockLevel === undefined) return false

  return currentStockLevel <= (stockAlertLevel || 0)
}

export const getStockText = (
  props: { medication: ResidentMedication },
  t: (key: string) => string
): string | null => {
  const { medication } = props
  const { unit, currentStockLevel } = medication

  if (currentStockLevel === undefined) return null

  if (currentStockLevel === 0) return t('OUT_OF_STOCK')

  return `${currentStockLevel} ${unit ? `${unit} ` : ' '}${t('LEFT')}`
}

export const getSubLabel = (
  medication: ResidentMedication,
  t: (key: string) => string
): string | null => {
  const { lastStockRecordDate, updatedAt } = medication
  
  // Determine which date is newer
  let dateToFormat: string | undefined
  let nameToUse: string | undefined
  
  if (lastStockRecordDate && updatedAt) {
    const lastStockDate = dayjs(lastStockRecordDate)
    const updatedDate = dayjs(updatedAt)
    
    if (lastStockDate.isAfter(updatedDate)) {
      dateToFormat = lastStockRecordDate
      nameToUse = medication.lastStockRecordedByName
    } else {
      dateToFormat = updatedAt
      nameToUse = medication.updatedByName
    }
  } else if (lastStockRecordDate) {
    dateToFormat = lastStockRecordDate
    nameToUse = medication.lastStockRecordedByName
  } else if (updatedAt) {
    dateToFormat = updatedAt
    nameToUse = medication.updatedByName
  }
  
  const formattedTimestamp = dateToFormat
    ? dayjs(dateToFormat).format('DD-MM-YYYY • HH:mm')
    : null

  if (!formattedTimestamp) return null

  const updatedByText = nameToUse ? ` • ${nameToUse}` : ''

  return `${t('UPDATED')} ${formattedTimestamp}${updatedByText}`
}
